import { UI } from '@newageerp/nae-react-ui';
import { INaeWidget } from '@newageerp/nae-react-ui/dist/interfaces';
import { Fragment } from 'react';

export const GeneratedLayoutWidgets: INaeWidget[] = [
];
